import { render, staticRenderFns } from "./innerDetail.vue?vue&type=template&id=200cfffa&scoped=true"
import script from "./innerDetail.vue?vue&type=script&lang=js"
export * from "./innerDetail.vue?vue&type=script&lang=js"
import style0 from "./innerDetail.vue?vue&type=style&index=0&id=200cfffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200cfffa",
  null
  
)

export default component.exports